import { defineMessages } from 'react-intl';
import globalMessages from 'messages';
import projectMessages from 'messages/Models/Project';
import pendingQuoteMessages from 'messages/Workbench/ProjectDetail/Bottom/PendingQuote';
import makingQuoteMessages from 'messages/Workbench/ProjectDetail/Bottom/Making';

const localMessages = defineMessages({
  'menuKeys.detail': '需求详情',
  'menuKeys.progress': '状态进度',

  'panelKeys.baseInfo': '需求单基本信息',
  'panelKeys.settleInfo': '报价结算信息',
  'panelKeys.planInfo': '策划信息',
  'panelKeys.descInfo': '需求单详情描述',
  'panelKeys.timeGannt': '时间',
  'panelKeys.flowNode': '流程节点',
  'panelKeys.journals': '更新历史',
  'panelKeys.payInfo': '付款信息',

  lightBoxImageName: '内容描述图片',
  expectDate: '预估时间',
  actualDate: '实际时间',
  uploadTips: '( 单个文件不超过200M )',
});

const messages = {
  ...globalMessages,
  ...projectMessages,
  ...pendingQuoteMessages,
  ...makingQuoteMessages,
  ...localMessages,
};

export default messages;
